import { gql } from "urql";

import type { BatchClaimFilter } from "../gql/graphql";

interface ClaimLifecycleAggregateRow {
  keys?: (string | null)[] | null;
  distinctCount?: {
    id?: number | null;
  } | null;
}

export interface ClaimLifecycleAggregatesQuery {
  phasesSummary?: {
    groupedAggregates?: (ClaimLifecycleAggregateRow | null)[] | null;
  } | null;
}

export interface ClaimLifecycleAggregatesQueryVariables {
  batchClaimFilter: BatchClaimFilter;
}

export const getClaimLifecycleAggregatesQueryDoc = gql`
  query getClaimLifecycleAggregates($batchClaimFilter: BatchClaimFilter!) {
    phasesSummary: batchClaimStates(
      filter: {
        and: [
          { batchClaimById: $batchClaimFilter }
          { currentPhaseId: { isNull: false } }
        ]
      }
    ) {
      groupedAggregates(groupBy: CURRENT_PHASE_ID) {
        keys
        distinctCount {
          id
        }
      }
    }
  }
`;

export const getClaimLifecycleAggregatesForProvidersQueryDoc = gql`
  query getClaimLifecycleAggregatesForProviders(
    $batchClaimFilter: BatchClaimFilter!
  ) {
    phasesSummary: batchClaimStates(
      filter: {
        and: [
          { batchClaimById: $batchClaimFilter }
          { isProviderActive: { equalTo: true } }
          { currentPhaseId: { isNull: false } }
        ]
      }
    ) {
      groupedAggregates(groupBy: CURRENT_PHASE_ID) {
        keys
        distinctCount {
          id
        }
      }
    }
  }
`;
